import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles, and, not, or } from '@/js/libs/use-auth';

import BusinessIntelligence from 'src/scenes/BusinessIntelligence';
import Status from 'src/scenes/Status';

const index = true;

export const businessIntelligenceRouteObject = inferRouteObject({
  path: 'business-intelligence',
  element: (
    <PrivateRoute roles={or(Roles.ADMIN, and(Roles.REPORT_BUILDER, not(Roles.POSTNETZ_BRANCH_USER)))} noAccessComponent={Status.NotFound} />
  ),
  children: [
    {
      Component: BusinessIntelligence.Helmet,
      children: [
        { path: 'reporting', element: <Navigate to='./campaign/list' replace /> },
        {
          path: 'reporting-v2',
          children: [
            { index, element: <Navigate to='./list' replace /> },
            { path: 'list', Component: BusinessIntelligence.Reporting.ListV2 },
          ],
        },
        {
          path: 'reporting/:type',
          Component: BusinessIntelligence.Reporting.Layout,
          children: [
            { path: 'list', Component: BusinessIntelligence.Reporting.List },
            { path: ':templateId', Component: BusinessIntelligence.Reporting.ReportType },
            { index, Component: BusinessIntelligence.Reporting.Report },
          ],
        },
        {
          path: 'visualizations',
          children: [
            {
              path: 'dashboards',
              children: [
                { path: 'new', Component: BusinessIntelligence.Visualizations.DashboardEdit },
                {
                  path: ':dashboardId',
                  children: [
                    { path: 'edit', Component: BusinessIntelligence.Visualizations.DashboardEdit },
                    { index, Component: BusinessIntelligence.Visualizations.DashboardView },
                  ],
                },
                { index, Component: BusinessIntelligence.Visualizations.Dashboards },
              ],
            },
            {
              path: 'widgets',
              children: [
                { path: 'new', Component: BusinessIntelligence.Visualizations.Widget },
                { path: ':widgetId', Component: BusinessIntelligence.Visualizations.Widget },
                { index, Component: BusinessIntelligence.Visualizations.Widgets },
              ],
            },
            { index, element: <Navigate to='./dashboards' replace /> },
          ],
        },
        { index, element: <Navigate to='./reporting/campaign/list' replace /> },

        // hidden till redesign https://gitlab.audienzz.ch/audienzz/audienzz/-/issues/15523
        // {
        //   path: 'dashboard',
        //   element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
        //   children: [
        //     {
        //       Component: BusinessIntelligence.Dashboard.Layout,
        //       children: [
        //         {
        //           path: 'page',
        //           children: [
        //             {
        //               path: ':pageId',
        //               children: [
        //                 {
        //                   path: 'visualization',
        //                   children: [
        //                     { path: ':itemId', Component: BusinessIntelligence.Dashboard.EditVisualizationPage },
        //                     { index, element: <Navigate to='..' replace /> },
        //                   ],
        //                 },
        //                 {
        //                   path: 'visualization-new',
        //                   Component: BusinessIntelligence.Dashboard.EditVisualizationPage,
        //                 },
        //                 {
        //                   index,
        //                   Component: BusinessIntelligence.Dashboard.SinglePage,
        //                 },
        //               ],
        //             },
        //             { index, element: <Navigate to='..' replace /> },
        //           ],
        //         },
        //         {
        //           index,
        //           Component: BusinessIntelligence.Dashboard.MainPage,
        //         },
        //       ],
        //     },
        //   ],
        // },
      ],
    },
  ],
});
